import * as React from 'react';
import { useFormikContext } from 'formik';
import { SkipButton } from '../../../../components/QuestionActions/components/SkipButton';
import { jsx as _jsx } from "react/jsx-runtime";
export var SecondarySubmitActionContainer = function SecondarySubmitActionContainer(props) {
  var fields = props.question.fields;
  var _useFormikContext = useFormikContext(),
    submitForm = _useFormikContext.submitForm,
    setFieldValue = _useFormikContext.setFieldValue;

  /**
   * При клике на "Пропустить вопрос" выполняется сброс возможных предыдущих полей к undefined, и далее сабмит шага
   * */
  var onClick = React.useCallback(function () {
    fields.forEach(function (_ref) {
      var name = _ref.name;
      return setFieldValue(name, undefined, false);
    });
    submitForm();
  }, [fields, setFieldValue, submitForm]);
  return /*#__PURE__*/_jsx(SkipButton, {
    onClick: onClick,
    children: props.children
  });
};
SecondarySubmitActionContainer.displayName = 'SecondarySubmitActionContainer';